import Model, { attr, belongsTo } from '@ember-data/model';

// This model mirrors ./register-redirection-token.js (see app/services/api-flow-manager.js for
// why both exist). Partner-derived getters here (isAccountant, isEmbedded, isLegalPlace, ...)
// must stay in sync with that model's — this one is tried first for every redirection token.
export default class RedirectionToken extends Model {
  @attr('string') flowUserType;
  @attr('string') ownerEmail;
  @attr('string') partnerName;
  @attr('string') ownerFirstName;
  @attr('string') organizationName;
  @attr('string') organizationId;
  @attr('string') flowType;
  @attr('string') organizationLegalCountry;
  @attr('string') legalFlow;
  @attr('string') locale;
  @attr('string') partnerType;
  @attr('boolean') companyCreationFromScratch;

  @belongsTo('registration', { async: true, inverse: null }) registration;

  get registrationID() {
    return this.belongsTo('registration').id();
  }

  get isAccountant() {
    return this.partnerType === 'accountant';
  }

  get isEmbedded() {
    return this.partnerType === 'embed';
  }

  get isLegalPlace() {
    return this.partnerName?.toLowerCase() === 'legal-place';
  }
}
